var map = {
	"./belgie-Dinsdag.png": 4557,
	"./belgie-Donderdag.png": 6833,
	"./belgie-Maandag.png": 9792,
	"./belgie-Vrijdag.png": 9774,
	"./belgie-Woensdag.png": 2187,
	"./belgie-Zaterdag.png": 8993,
	"./belgie-Zondag.png": 9958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7486;